import cookie from 'react-cookie';
import { getSessionData, getGA } from '../actions/personalize'
import WorthyApi from './api/worthyApi'

export default class User {
    constructor(userData) {
        this._userData = userData;
    }

    get userData() {
        return this._userData;
    }
    set userData(newUserData) {
        throw "Can't set userData object";
    }

    get id() {
        return this.userData?.id;
    }
    set id(id) {
        throw "Can't set id";
    }

    get email() {
        return this.userData?.email;
    }
    set email(newEmail) {
        throw "Can't set email";
    }

    get phone() {
        return this.userData?.phone;
    }
    set phone(newPhone) {
        throw "Can't set phone";
    }

    get name() {
        return `${this.userData?.first_name} ${this.userData?.last_name}`;
    }
    set name(newName) {
        throw "Can't set name";
    }

    get first_name() {
        return this.userData?.first_name
    }
    set first_name(newName) {
        throw "Can't set first name";
    }

    get last_name() {
        return this.userData?.last_name
    }
    set last_name(newName) {
        throw "Can't set last name";
    }

    get business() {
        return this.userData?.seller_type === 1 ? true : false;
    }
    set business(newBusiness) {
        throw "Can't set business field";
    }

    get account_manager() {
        return this.userData?.account_manager;
    }
    set account_manager(newAccountManager) {
        throw "Can't set account manager field";
    }

    get local_time() {
        return this.userData?.local_time;
    }
    set local_time(newAccountManager) {
        throw "Can't set local time field";
    }

    get lead_id() {
        return this.userData && (this.userData.type == 'user' ? this.userData.lead_id : this.userData.id);
    }
    set lead_id(newLeadId) {
        throw "Can't set local time field";
    }

    // Start Global

    isLoggedIn() {
        return this.lead_id !== null
    }

    updateUserData(newUserData) {
        this._userData = Object.assign({}, this._userData, newUserData);
    }

    isUser() {
        return this.userData?.type === 'user'
    }

    // End Global


    // Start Static

    static loadReferer() {
        let referer = cookie.load('worthy_referer')
        return referer ? referer : null;
    }

    static loadRefererFriendbuy() {
        let friendbuy_referer = cookie.load('friendbuy_referer')
        return friendbuy_referer ? friendbuy_referer : null;
    }

    static _getUserData() {
        return cookie.load('userData');
    }

    static logOut() {
        return cookie.save('userPerformedLogOut', true, {path: '/', expires: new Date(new Date().setYear(new Date().getFullYear() + 10))});
    }

    static performedLogOut() {
        return !!cookie.load('userPerformedLogOut');
    }

    static _clearUserData() {
        return cookie.remove('userData');
    }

    static performedLogin(userId) {
        // This function will send a notification on session login to data collector once per session - based on a session cookie.
        // get the session cookie
        const cookieName = 'loggedInUser'
        const loginCookie = cookie.load(cookieName);
        
        // get additional details for comparing the cookie
        const visitorId = getGA()
        const sessionIdentifier = getSessionData().sessionIdentifier
        
        if (!loginCookie ||
            loginCookie.userId !== userId || 
            loginCookie.visitorId !== visitorId ||
            loginCookie.sessionIdentifier !== sessionIdentifier) {
            // notify data collector.
            WorthyApi.userLoggedIn(sessionIdentifier, userId)
            cookie.save(cookieName, { userId, visitorId, sessionIdentifier });
        }
    }
    // End Static
}
